import { ConfirmClient, UserSessionManager, UserSessionStore } from '@aon/aon-tws-common-ui';
import { ActionCreators } from '@aon/aon-tws-common-ui/build/lib/components/ClientContext/ClientContextStore';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import Constants from '../../constants';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import userManager from '../../userManager';

export type ConfirmClientPageProps = RouteComponentProps<{}> | undefined;

export const ConfirmClientContainer: any = connect(
	(state: IApplicationState) => ({
		...state.clientContextList,
	}),
	{
		...ActionCreators,
		...NavigationActions,
		logout: UserSessionStore.logout,
	},
)(ConfirmClient);

export class ConfirmClientPage extends React.PureComponent<ConfirmClientPageProps> {
	public render() {
		return (
			<>
				<UserSessionManager
					sessionKeyPrefix='SB'
					clientLogoutUrl={Constants.API_CLIENT_LOGOUT_URL}
					identityServerUrl={Constants.IDENTITY_SERVER_URL}
					landingPageRoute={Constants.ADMINPORTAL_URL + Constants.ROUTE_LANDING}
					timeoutInSeconds={Constants.SESSION_TIMEOUT}
					userManager={userManager}
				/>

				<ConfirmClientContainer
					{...this.props}
					identityServerUrl={Constants.IDENTITY_SERVER_URL}
					userManagementBaseUrl={Constants.USER_MANAGEMENT_API_URL}
					userManager={userManager}
				/>
			</>
		);
	}
}
